class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
    this.isSliderActive = false;
  }

  connectedCallback() {
    this.checkViewport();
    window.addEventListener('resize', this.checkViewport.bind(this));
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
    window.removeEventListener('resize', this.checkViewport.bind(this));
  }

  initSlider() {
    const sliderWrapper = this.querySelector('.slider-wrapper');
    const slides = Array.from(this.querySelectorAll('.slide'));

    // Clear any previous cloned slides
    sliderWrapper.innerHTML = '';

    // Append original slides
    slides.forEach((slide) => {
      sliderWrapper.appendChild(slide);
    });

    // Clone slides to ensure seamless looping
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      sliderWrapper.appendChild(clone);
    });

    let currentIndex = 0;

    const moveToSlide = (index) => {
      sliderWrapper.style.transition = 'transform 0.5s ease-in-out';
      sliderWrapper.style.transform = `translateX(-${index * 100}%)`;
    };

    const resetSlider = () => {
      sliderWrapper.style.transition = 'none';
      sliderWrapper.style.transform = `translateX(0)`;
      currentIndex = 0;
    };

    const startSlider = () => {
      this.intervalId = setInterval(() => {
        currentIndex++;
        moveToSlide(currentIndex);

        if (currentIndex >= slides.length) {
          setTimeout(() => {
            resetSlider();
          }, 500);
        }
      }, 3000);
    };

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 575 && this.isSliderActive) {
        moveToSlide(currentIndex);
      }
    });

    resetSlider();
    startSlider();
  }

  checkViewport() {
    const sliderWrapper = this.querySelector('.slider-wrapper');
    const slides = Array.from(this.querySelectorAll('.slide'));

    if (window.innerWidth <= 575) {
      if (!this.isSliderActive) {
        this.isSliderActive = true;
        this.initSlider();
      }
    } else {
      if (this.isSliderActive) {
        this.isSliderActive = false;
        clearInterval(this.intervalId);

        // Clear the slider wrapper and reappend original slides
        sliderWrapper.innerHTML = '';
        slides.slice(0, slides.length / 2).forEach((slide) => {
          sliderWrapper.appendChild(slide);
        });

        // Reset slider styles
        sliderWrapper.style.transition = 'none';
        sliderWrapper.style.transform = 'none';
      }
    }
  }
}

customElements.define('custom-slider', CustomSlider);
